import api from '../services/api';

/**
 * Name → dashboard route for every supported platform.
 * Must stay in sync with the plataformas[] array in PlataformaSelector.jsx.
 */
export const PLATFORM_ROUTES = {
  'HTML/CSS':    '/dashboard/guia-htmlcss',
  'Wordpress':   '/dashboard/guia-wordpress',
  'WordPress':   '/dashboard/guia-wordpress',
  'Shopify':     '/dashboard/guia-shopify',
  'SquareSpace': '/dashboard/guia-squarespace',
  'Webflow':     '/dashboard/guia-webflow',
  'Wix':         '/dashboard/guia-wix',
  'Magento':     '/dashboard/guia-magento',
  'Joomla':      '/dashboard/guia-joomla',
  'Drupal':      '/dashboard/guia-drupal',
  'OpenCart':    '/dashboard/guia-opencart',
  'HubSpot':     '/dashboard/guia-hubspot',
  'Moodle':      '/dashboard/guia-moodle',
  'PrestaShop':  '/dashboard/guia-prestashop',
  'Weebly':      '/dashboard/guia-weebly',
  'Duda':        '/dashboard/guia-duda',
};

/**
 * Fast client-side detection based on URL subdomain patterns.
 * Covers SaaS builders where the platform is visible in the domain itself.
 */
const URL_PATTERNS = [
  { platform: 'Wix',         regex: /\.wixsite\.com|wixstatic\.com/i },
  { platform: 'Shopify',     regex: /\.myshopify\.com/i },
  { platform: 'SquareSpace', regex: /\.squarespace\.com/i },
  { platform: 'Webflow',     regex: /\.webflow\.io/i },
  { platform: 'HubSpot',     regex: /\.hs-sites\.com|\.hubspotpagebuilder\.com/i },
  { platform: 'Duda',        regex: /\.dudaone\.com|\.multiscreensite\.com/i },
  { platform: 'Weebly',      regex: /\.weebly\.com|\.editmysite\.com/i },
  { platform: 'Moodle',      regex: /moodle\./i },
];

/**
 * Instant URL-pattern check — no network request needed.
 * @param {string} url
 * @returns {string|null}
 */
export function detectPlatformFromUrl(url) {
  for (const { platform, regex } of URL_PATTERNS) {
    if (regex.test(url)) return platform;
  }
  return null;
}

/**
 * Full platform detection.
 * 1. Instant URL-pattern check.
 * 2. Backend call: the server fetches the page HTML and inspects signatures.
 *    Always resolves (never throws) — returns null when detection fails.
 *
 * @param {string} url - Full URL or domain (e.g. "https://mysite.com" or "mysite.com")
 * @returns {Promise<string|null>}
 */
export async function detectPlatform(url) {
  const fromUrl = detectPlatformFromUrl(url);
  if (fromUrl) return fromUrl;

  try {
    const { data } = await api.post('/detect-platform', { url });
    return data?.platform ?? null;
  } catch {
    return null;
  }
}
